'use strict';

import angular from 'angular';

export default class GrpAtrTypeFormCtrl {
  model = {
    name: '',
    isActive: true
  };
  // Auth; //TODO: add auth check

  constructor($state, $stateParams, LoaderSvc, GrpAtrTypeSvc, GroupAuthSvc,
    GrpTypeSvc, GroupSvc) {
    var groupId = $stateParams.groupId;
    this.groupId = groupId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.GrpAtrTypeSvc = GrpAtrTypeSvc;
    this.LoaderSvc = LoaderSvc;

    var that = this;

    this.isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(this.isCreate) {
      // authorization
      GroupAuthSvc.validatePermission(this.groupId, 'groupAttributeType', 'C');

      this.submit = this.createGrpAtrType;
      that.headerText = 'New Group Attribute';
      that.submitText = 'Create Group Attribute';
      GroupSvc.get({groupId}).$promise.then(function(group) {
        return GrpTypeSvc.getDesc({groupId}).$promise
          .then(function(gt) {
            var parentGrp = {name: group.name};
            that.model.groupType = parentGrp;
            that.groupTypes = [parentGrp].concat(gt);
          });
      });

      this.cancelSref = 'group.view.settings.groupAttributeType.list';

    // edit
    } else {
      // authorization
      GroupAuthSvc.validatePermission(this.groupId, 'groupAttributeType', 'U');

      this.submit = this.updateGrpAtrType;
      var ptId = $stateParams.ptId;
      that.ptId = ptId;
      that.headerText = 'Edit Group Attribute';
      that.submitText = 'Update Group Attribute';
      this.GrpAtrTypeSvc.get({groupId, id: ptId}).$promise
        .then(function(pt) {
          that.model = angular.copy(pt);
          that.displayGT = pt.groupType ? pt.groupType : pt.definedByGroup;
        });
      this.cancelSref = 'group.view.settings.groupAttributeType.list';
    }
  }

  createGrpAtrType() {
    var that = this;
    that.LoaderSvc.start();
    var model = that.model;
    model.definedByGroupId = Number(that.groupId);
    that.GrpAtrTypeSvc.create({groupId: that.groupId}, this.model).$promise
      .then(function(pt) {
        that.LoaderSvc.stopSuccess('Group Attribute Created');
        that.$state.go('group.view.settings.groupAttributeType.list',
          {ptId: pt.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updateGrpAtrType() {
    var that = this;
    that.LoaderSvc.start();

    this.GrpAtrTypeSvc
      .update({groupId: that.groupId, id: that.ptId}, this.model).$promise
      .then(function() {
        that.$state
          .go('group.view.settings.groupAttributeType.list', {ptId: that.ptId});
        that.LoaderSvc.stopSuccess('Group Attribute Updated');
      })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}

GrpAtrTypeFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'GrpAtrTypeSvc',
  'GroupAuthSvc',
  'GrpTypeSvc',
  'GroupSvc'
];
